// https://blog.csdn.net/weixin_42512937/article/details/103484986
export default {
  data() {
    return {
      total: 0,
      pageSize: 20,
      currentPage: 1,
      sizesArray: [10, 20, 50, 100]
    }
  },
  watch: {
    total(val) {
      let { total, currentPage, pageSize } = this
      console.debug('total: ', total, currentPage, pageSize, currentPage * pageSize, (val <= ((currentPage-1) * pageSize)))
      if ( val <= ((currentPage-1) * pageSize) ) {
        this.handleCurrentChange(1)
      }
    }
  },
  methods: {
    handleCurrentChange(value) {
      console.debug('handleCurrentChange', value, this)
      this.currentPage = value;
    },
    handleSizeChange(value) {
      console.debug('handleSizeChange', value, this)
      this.pageSize = value
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/initPagin.js